import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const odpAdminPlugin = createPlugin({
  id: 'odp-admin',
  routes: {
    root: rootRouteRef,
  },
});

export const OdpAdminPage = odpAdminPlugin.provide(
  createRoutableExtension({
    name: 'OdpAdminPage',
    component: () => import('./App').then(m => m.App),
    mountPoint: rootRouteRef,
  }),
);
